<template>
    <mm-tab-title>
        <el-button slot="save" size="medium" type="primary" @click="submit">Test</el-button>
        <div>
        <el-form ref="form" size="small" label-width="200px">
            <el-form-item label="Test Link" prop="link">
                <el-input v-model="where.link" placeholder="测试链接以http或https开头,如修改了postback,请等待15分钟后测试"/>
            </el-form-item>
            <el-form-item label="Analog IP" prop="ip">
                <el-input v-model="where.ip" placeholder="default 8.8.8.8"/>
            </el-form-item>
            <el-form-item label="Platform" prop="platform">
                <el-radio-group v-model="where.platform">
                    <el-radio label='Mozilla/5.0 (Linux; Android 4.4.2; Nexus 4 Build/KOT49H) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/34.0.1847.114 Mobile Safari/537.36'>Android</el-radio>
                    <el-radio label='Mozilla/5.0 (iPhone; CPU iPhone OS 6_0 like Mac OS X) AppleWebKit/536.26 (KHTML, like Gecko) Version/6.0 Mobile/10A5376e Safari/8536.25'>IOS</el-radio>
                    <el-radio label='Mozilla/5.0 (MSIE 10.0; Windows NT 6.1; Trident/5.0)'>Windows</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="Redirection history" prop="history"  >
                <el-input v-model="where.history" type="textarea" :rows="6" />
            </el-form-item>
            <el-form-item label="Postback Log" prop="log"  >
                <el-input v-model="where.log" type="textarea" :rows="6" />
            </el-form-item>
        </el-form>

        </div>
    </mm-tab-title>


</template>

<script>
export default {
	data() {
		return {
			where: {
				link: '',
				ip: '',
				platform: 'Mozilla/5.0 (Linux; Android 4.4.2; Nexus 4 Build/KOT49H) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/34.0.1847.114 Mobile Safari/537.36',
				history: '',
				log: '',
			}
		};
	},
	methods: {
		async submit() {
			for(const value of ['link','platform']) {
				if(this.where[value] == '') {
					this.$message({
						type: 'error',
						message: 'Missing ' + value
					})
					return;
				}
			}
			this.where.ip = this.where.ip == '' ? '8.8.8.8' : this.where.ip;
			// console.log(this.where);
			let result = await this.$post('/postback/link',this.where);
			// console.log(result);
			// console.log(typeof(result.message))
			this.where.history = result.history.join('\n');
			if(result.clickid == null) {
				this.$message({
					type: 'error',
					message : 'False ,please check the test link \n message:' + result.message

				})
				return;
			}
			this.getContents(result.clickid);
		},
		async getContents(clickid) {
			let result = await this.$post('/postback/make',{clickid: clickid});
			if (result && result.success === 1) {
				if (result.postback) {
					this.where.log = result.postback.join('\n');
				}
				this.$message({
					type: 'success',
					message: 'Success please tell your channel AM to check',
				})
			} else {
				this.$message({
					type: 'error',
					message: 'False, please retry it later \n'+JSON.stringify(result),
				})
			}

		}
	},
};
</script>